import CustomList from '../Util/List/CustomList/CustomList';
import CustomListContainer from '../Util/List/CustomList/CustomListContainer';
import config from '../../../../application/config/config';
import { loadData } from '../Util/List/CustomList/loadData';
import { useState } from 'react';

const initialValues = {
    status: '1',
};

const statusOptions = [{ label: 'Ativo', value: '1' }, { label: 'Inativo', value: '0' }];

function List() {
    const [values, setValues] = useState(initialValues);

    const pathFrontEnd = '/core/users/';
    const paths = {
        pathAdd: pathFrontEnd + 'add',
        pathEdit: pathFrontEnd + 'edit',
        pathView: pathFrontEnd + 'view',
        endpoint: config.endpoints.backend + 'core/users/getall',
        endpointUpdate: config.endpoints.backend + 'core/users/save',
        endpointDelete: `${config.endpoints.backend}core/users/delete`,
        endpointGetAllProfiles: config.endpoints.backend + 'core/applicationsprofiles/getall',
        endpointGetAllInstances: config.endpoints.backend + 'core/applicationsinstances/getall',
    };

    const handleChange = (form) => {
        const name = form['target']['name'];
        const value = form['target']['value'];

        setValues(prev => ({ ...prev, [name]: value }));
    };

    const filters = {
        validateOnChange: true,
        showGoBackButton: false,
        showSubmitButton: false,
        handleSubmit: loadData,
        fields: [
            {
                name: 'application_instance_id',
                type: 'select',
                label: 'Instalação',
                handleChange,
                isClearable: true,
                options: [],
                optionsEndpoint: {
                    value: "id",
                    label: "instance_name",
                    endpoint: paths.endpointGetAllInstances,
                },
                validations: { required: false },
                columnSize: 3
            },
            {
                name: 'application_profile_id',
                type: 'select',
                label: 'Perfil de Acesso',
                handleChange,
                isClearable: true,
                options: [],
                optionsEndpoint: {
                    value: "id",
                    label: "profile_name",
                    endpoint: paths.endpointGetAllProfiles,
                },
                validations: { required: false },
                columnSize: 3
            },
            {
                name: 'status',
                type: 'select',
                label: 'Status',
                handleChange,
                isClearable: true,
                options: statusOptions,
                validations: { required: false },
                columnSize: 3
            },
            {
                name: 'filtro',
                type: 'submit',
                label: 'Pesquisar',
                columnSize: 1
            }
        ],
        values: { ...values },
    };

    const list = {
        labelTitle: 'Lista de Usuários',
        labelTitleButtonAdd: 'Incluir novo usuário',
        fieldsShowOnDelete: ['name', 'instance_name'],
        showPrintButtons: true,
        canDelete: false,
        formFilters: filters,
        columns: [
            {
                name: 'name',
                label: 'Usuário'
            },
            {
                name: 'instance_name',
                label: 'Instalação'
            },
            {
                name: 'profile_name',
                label: 'Perfil'
            },
            {
                name: 'status',
                label: 'Status',
                type: "select",
                width: '20%',
                editable: true,
                minWidth: '120px',
                options: statusOptions,
                endpointSave: paths.endpointUpdate,
            },
        ],
        ...paths
    };

    return (
        <div>
            <CustomListContainer
                pathAdd={list.pathAdd}
                labelTitle={list.labelTitle}
                labelTitleButtonAdd={list.labelTitleButtonAdd}
                content={<CustomList list={list} />}
            />
        </div>
    );
}
export default List;